module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"logout":"Sair","profile":"Perfil"},"en-US":{"logout":"Logout","profile":"Profile"}}')
  delete Component.options._Ctor
}
